import React from 'react';

export const categoryLabels = {
     APN: 'Apnea',
     AHI: 'HypoApnea',
     CAN: 'Central Apnea',
     MOV: 'Movement',
     IRR: 'Irregularities',
     GSD: 'Good Signal Duration',
     TST: 'Total Sleep Time',
     TBT: 'Total Bed Time',     
     TBR: 'Total Breathing Time',
     OBS: 'Obstructive Apnea'
}

export const denominators = { GSD: true, TST: true, TBT: true, TBR: true }

export const treeData = [
     {
       title: 'All Categories',
       key: 'all',
       disabled: true,
       children: [
         {
           title: 'Apnea',
           value: 'APN',
         },
         {
          title: 'Central Apnea',
          value: 'CAN',
         },
          {
          title: 'Obstructive Apnea',
          value: 'OBS',
         },
         {
             title: 'Irregularities',
             value: 'IRR',
         },
       ],
     },
     {
       title: 'Divisor',
       value: 'DIVISOR',
       disabled: true,
       children: [
         {
             title: <b style={{ color: '#08c' }} >Total Sleep Time</b>,
             value: 'TST',
         },
         {
             title: <b style={{ color: '#08c' }} >Total Bed Time</b>,
             value: 'TBT',
         },
         {
             title: <b style={{ color: '#08c' }} >Total Breathing Time</b>,
             value: 'TBR',
         },
       ],
     },
   ];